import {
  FETCH_CONVERTOR_RATES_GRAPH_REQUEST,
  FETCH_CONVERTOR_RATES_GRAPH_SUCCESS,
  FETCH_CONVERTOR_RATES_GRAPH_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {};

export const ratesGraph = createReducer(initialState, {
  [FETCH_CONVERTOR_RATES_GRAPH_REQUEST]: (
    state,
    { payload: { currenciesKey, periodKey } }
  ) => ({
    ...state,
    [currenciesKey]: {
      ...(state[currenciesKey] || {}),
      [periodKey]: {
        ...(state[currenciesKey]?.[periodKey] || {}),
        isFetching: true,
        isInitialized: false,
      },
    },
  }),

  [FETCH_CONVERTOR_RATES_GRAPH_SUCCESS]: (
    state,
    { payload: { currenciesKey, periodKey, entities, ids } }
  ) => ({
    ...state,
    [currenciesKey]: {
      ...state[currenciesKey],
      [periodKey]: {
        ...state[currenciesKey][periodKey],
        entities,
        ids,
        isFetching: false,
        isInitialized: true,
      },
    },
  }),

  [FETCH_CONVERTOR_RATES_GRAPH_FAILURE]: (
    state,
    { payload: { currenciesKey, periodKey } }
  ) => ({
    ...state,
    [currenciesKey]: {
      ...state[currenciesKey],
      [periodKey]: {
        ...state[currenciesKey][periodKey],
        isFetching: false,
        isInitialized: true,
      },
    },
  }),
});

export default ratesGraph;
